import React, { FC } from 'react';
import Icon from '@/components/extra/Icon/Icon';

interface AnimationControlPrimaryProps {
    uniqueId: string | number;
}

const AnimationControlPrimary: FC<AnimationControlPrimaryProps> = ({
    uniqueId,
}) => {
    return (
        <div className="Animation_controlGroup Animation_controlGroup--left">
            <div className="Animation_interactiveWrap">
                <button
                    id={`PlayToggle_${uniqueId}`}
                    className="Animation_btnView Animation_btnView--round"
                >
                    <Icon icon="caret" />
                </button>
                <div
                    id={`PlayToggleHudTooltip_${uniqueId}`}
                    className="Animation_hudTooltip"
                >
                    Abspielen
                </div>
            </div>

            <div id={`ButtonPair_${uniqueId}`} className="Animation_buttonPair">
                <div className="Animation_interactiveWrap">
                    <button
                        id={`PrevFrame_${uniqueId}`}
                        className="Animation_btnView"
                    >
                        <Icon icon="chevron" className="IconPrevFrame" />
                    </button>
                    <div className="Animation_hudTooltip">Vorheriges Bild</div>
                </div>
                <div className="Animation_interactiveWrap">
                    <button
                        id={`NextFrame_${uniqueId}`}
                        className="Animation_btnView"
                    >
                        <Icon icon="chevron" />
                    </button>
                    <div className="Animation_hudTooltip">Nächstes Bild</div>
                </div>
            </div>
        </div>
    );
};

export default AnimationControlPrimary;
